var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakerphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.66647C15.663 6.66647 16.2989 6.92986 16.7678 7.3987C17.2366 7.86754 17.5 8.50342 17.5 9.16647C17.5 9.82951 17.2366 10.4654 16.7678 10.9342C16.2989 11.4031 15.663 11.6665 15 11.6665M8.33333 6.66647V15.8331C8.33333 16.0541 8.24554 16.2661 8.08926 16.4224C7.93298 16.5787 7.72101 16.6665 7.5 16.6665H6.66667C6.44565 16.6665 6.23369 16.5787 6.07741 16.4224C5.92113 16.2661 5.83333 16.0541 5.83333 15.8331V11.6665M10 6.66646L13.77 3.52479C13.8795 3.43355 14.0128 3.37542 14.1542 3.35721C14.2956 3.33901 14.4393 3.36148 14.5684 3.422C14.6975 3.48252 14.8066 3.57858 14.8831 3.69892C14.9595 3.81926 15.0001 3.95889 15 4.10146V14.2315C15.0001 14.374 14.9595 14.5137 14.8831 14.634C14.8066 14.7543 14.6975 14.8504 14.5684 14.9109C14.4393 14.9714 14.2956 14.9939 14.1542 14.9757C14.0128 14.9575 13.8795 14.8994 13.77 14.8081L10 11.6665H3.33333C3.11232 11.6665 2.90036 11.5787 2.74408 11.4224C2.5878 11.2661 2.5 11.0541 2.5 10.8331V7.49979C2.5 7.27878 2.5878 7.06682 2.74408 6.91054C2.90036 6.75426 3.11232 6.66646 3.33333 6.66646H10Z",
    stroke: "#2D3036",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerphone);
export default __webpack_public_path__ + "static/media/speakerphone.a4a66f50b8b9dbe2bdd47a5744eee2c2.svg";
export { ForwardRef as ReactComponent };